// extracted by mini-css-extract-plugin
export default {"bottom":"flight-request-add_bottom__JQaD6"};